import React from 'react';
import DSAd from './DSAd';
import { Theme, makeStyles, useMediaQuery } from '@material-ui/core';
import { MD_MEDIA_QUERY } from '../common/constants';
import { PartnerAdVariant } from '@skyslope/partnerships-sdk';
import { AdPlacementIds } from './DigiSignAdsProvider';
interface StyleProps {
  isMobile: boolean;
}
const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  dsAdContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
    marginTop: (props: StyleProps) => (props.isMobile ? theme.spacing(2) : theme.spacing(2)),
  },
}));

interface ISignerAdProps {}

const SignerAd: React.FC<ISignerAdProps> = (props: ISignerAdProps) => {
  const isMobile = useMediaQuery(MD_MEDIA_QUERY);
  const adVariant = isMobile ? PartnerAdVariant.MobileBanner : PartnerAdVariant.Banner;
  const classes = useStyles({
    isMobile: isMobile,
  });

  return (
    <div className={classes.dsAdContainer}>
      <DSAd id={AdPlacementIds.SIGNING} adVariant={adVariant}></DSAd>
    </div>
  );
};

export default SignerAd;
